import { ConfigMrCopyProtection } from '@net7/boilerplate-muruca';

export default {
  enabled: true,
  message: '\n\nInformación extraída de: https://calderondigital.tespasiglodeoro.it/\nCómo citarnos: Antonucci, Fausta et al. Calderón Digital. Base de datos, argumentos y motivos del teatro de Calderón.',
  htmlMessage: '<br><br>Información extraída de: <a href="https://calderondigital.tespasiglodeoro.it/" target="_blank">Calderón Digital. Base de datos, argumentos y motivos del teatro de Calderón</a>.<br><strong>Cómo citarnos</strong>: Antonucci, Fausta et al. <em>Calderón Digital. Base de datos, argumentos y motivos del teatro de Calderón.</em>',
} as ConfigMrCopyProtection;
